export default {
  loading: false,
  roles: [],
  role: {},
  totalCount: 0,
};
